//#region redux
import { useDispatch } from "react-redux";
import { revenueReportSnoozed } from "store/actions/revenueReportActions";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import { useSnoozeAction } from "components/common";
import { LocalizationHelperInstance } from "utils/helpers";

function useRevenueReportSnoozeAction(id: number | string, onActionSuccess?: () => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    onActionSuccess?.();
    dispatch(revenueReportSnoozed(id));
  };

  const { snoozeAction } = useSnoozeAction(
    String(id),
    WintSuperkollAPIModel.TodoType.RevenueReportNotSubmitted,
    onSnoozeSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TodoType_42)
  );

  return snoozeAction;
}

export default useRevenueReportSnoozeAction;
